<div class="bannerback">
  <app-nav></app-nav>
</div>

<div class="d-flex justify-content-between pt-5">
  <div class="d-flex">
    <img class="img-icon" src="../../../../../assets/v-4-icone/history.png" alt="loading" />
    <h2 class="font-600 color bottom-line p-0 dark-blue">
      {{ "Trainers" | translator }}
    </h2>
  </div>
</div>

<div class="d-flex flex-row align-items-center flex-wrap my-3 mx-3">
  <span class="d-flex align-items-center">
    <span (click)="changeRoute('/home')" class="custom-bredcrum-btn d-flex align-items-center">
      {{ "Homepage" | translator }}
    </span>
    <span class=""><i class="pi pi-fw pi-angle-left"></i></span>
  </span>
  <span class="d-flex align-items-center">
    <span class="custom-bredcrum-btn font-600 d-flex align-items-center">
      {{ "Trainers" | translator }}
    </span>
  </span>
</div>

<!-- Main View -->
<section class="container my-5" [hidden]="addTrainer">
  <p-selectButton class="v4-active" styleClass="d-flex justify-content-center my-3" (onChange)="getTrainers()"
    [options]="tabs" [(ngModel)]="typeFlag" [multiple]="false" optionLabel="name" optionValue="value"></p-selectButton>

  <div class="d-flex justify-content-end my-2">
    <button class="v4-btn-every py-2" [hidden]="typeFlag == 'External'" (click)="addTrainer = true">
      <i class="pi pi-plus v4-ml-2"></i>{{ "Add trainer" | translator }}
    </button>
  </div>
  <div class="d-flex justify-content-center my-2" *ngIf="typeFlag == 'External'">
    <p-dropdown [options]="companyData" [filter]="true" filterBy="name" (onChange)="getTrainers()"
      placeholder="{{'Select company' | translator}}" [(ngModel)]="companyFilter" optionLabel="name" inputId="float-label"></p-dropdown>
    <div class="v4-rotate">
      <i pTooltip="{{ 'Reset' | translator }}" (click)="refreshFilters()" tooltipPosition="top"
        class="fa-solid fa-arrows-rotate mx-3"></i>
    </div>
  </div>

  <div class="d-flex justify-content-center my-2" *ngIf="skeleton">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <section [hidden]="skeleton">
    <app-no-data [hidden]="trainerData.length > 0"></app-no-data>
    <p-table [hidden]="trainerData.length <= 0" styleClass="custom-table" [value]="trainerData" dataKey="code"
      [paginator]="true" [scrollable]="true" [rows]="10" [selectionPageOnly]="true"
      [tableStyle]="{ 'min-width': '40rem' }">
      <ng-template pTemplate="header">
        <tr>
          <th>{{ "the name" | translator }}</th>
          <th>{{ "Email" | translator }}</th>
          <th>{{ "Gender" | translator }}</th>
          <th>{{ "National ID" | translator }}</th>
          <th>{{ "Phone Number" | translator }}</th>
          <th *ngIf="typeFlag == 'Internal'">{{ "Action" | translator }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-trainer>
        <tr>
          <td>
            {{ trainer.name.first }} {{ trainer.name.middle }}
            {{ trainer.name.last }}
          </td>
          <td>{{ trainer.email }}</td>
          <td>{{ trainer?.gender }}</td>
          <td>{{ trainer?.national_id }}</td>
          <td>{{ trainer?.phone }}</td>
          <td>
            <div class="d-flex">
              <span pTooltip="{{ 'Remove trainer' | translator }}" tooltipPosition="top"
                class="tabel-circle-btn d-flex align-items-center" [hidden]="typeFlag == 'External'">
                <i (click)="confirmDeleteTrainer(trainer?._id)" class="fa fa-times"></i>
              </span>
              <span pTooltip="{{ 'View Rating Graph' | translator }}" tooltipPosition="top"
                class="tabel-circle-btn d-flex align-items-center">
                <i (click)="setratingUserID(trainer?._id)" class="pi pi-chart-bar"></i>
              </span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </section>
</section>


<!-- assNewTrainers -->
<!-- Add trainers -->
<section [hidden]="!addTrainer">
  <app-assign-users [userFetchUrl]="'user/get'" [selectionData]="[]" (selectedUsersList)="assNewTrainers($event)"
    [query]="{
      'externalUser.status': { $ne: true },
      'externalUser.role': { $nin: ['trainer', 'coordinator'] }
    }" *ngIf="addTrainer">
  </app-assign-users>
</section>

<p-dialog [blockScroll]="true" [draggable]="false" header="{{ 'Average Rating' | translator }}"
  [(visible)]="showRatingGraph" [modal]="true" [style]="{ width: '95vw', maxWidth: '1200px' }" [draggable]="false"
  [resizable]="false" (onHide)="ratingUserID = '' ">
  <ng-container *ngIf="ratingUserID != ''">
    <app-rating-graph [ratingUserID]="ratingUserID"></app-rating-graph>
  </ng-container>
</p-dialog>

<p-confirmDialog [style]="{ margin: '0rem 1rem' }"></p-confirmDialog>

<app-footer></app-footer>